class PopupMessage {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('.popup-message').forEach(function(elParent) {
            elParent.querySelectorAll('.button').forEach(function(el) {
                el.addEventListener('click', function() {
                    elParent.classList.add('popup-message--is-closing')
                    elParent.addEventListener('animationend', () => {
                        elParent.remove()
                    })
                }, true)
            })

        })
    }
}

export default PopupMessage